import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultNavbarComponent } from './components/default-navbar/default-navbar.component';
import { LogoModule } from '../logo/logo.module';
import { CoreModule } from '../core/core.module';
import { SidebarModule } from '../sidebar/sidebar.module';
import { NavbarMenuToggleButtonComponent } from './components/navbar-menu-toggle-button/navbar-menu-toggle-button.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Common2Module } from 'projects/common/src/app/app.module';
import { NavbarChangeSystemComponent } from './components/navbar-change-system/navbar-change-system.component';
import { NavbarOptionSoundComponent } from './components/navbar-option-sound/navbar-option-sound.component';
import { NavbarOptionSettingsComponent } from './components/navbar-option-settings/navbar-option-settings.component';
import { NavbarOptionProfileComponent } from './components/navbar-option-profile/navbar-option-profile.component';
import { DinamicNavbarDirective } from './directives/dinamic-navbar.directive';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    DefaultNavbarComponent,
    NavbarMenuToggleButtonComponent,
    NavbarChangeSystemComponent,
    NavbarOptionSoundComponent,
    NavbarOptionSettingsComponent,
    NavbarOptionProfileComponent,
    DinamicNavbarDirective,
  ],
  imports: [
    CommonModule,
    CoreModule,
    LogoModule,
    SidebarModule,
    NgbModule,
    Common2Module.forRoot(),
    MatRippleModule,
    MatIconModule,
  ],
  exports: [
    DefaultNavbarComponent,
    DinamicNavbarDirective,
  ]
})
export class NavbarModule { }
